import vFooter from './index.vue'

const Footer1 = {
  install: function (Vue) {
    Vue.component('Footer1', vFooter)
  }
}
export default Footer1



// WEBPACK FOOTER //
// ./src/components/footer/index.js